var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.text)?_c('div',{staticClass:"additional-text row"},[_c('options-fields-inline-editor',{staticClass:"col-8 offset-2 col-lg-12 offset-lg-0 text-center text-lg-left",attrs:{"component":_vm.component,"keyOption":_vm.text,"value":_vm.text}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }